module.exports = __webpack_public_path__ + "img/contact-portrait.b0e5517.png";